<template>
<v-container fluid>
  <v-row>
    <v-col cols="12">
      <v-data-table
          :items="items"
          :headers="headers"
          hide-default-footer
          disable-pagination
          >
        <template v-slot:item="props">
          <tr>
            <td>{{props.item.patient}}</td>
            <td>{{props.item.therapist}}</td>
            <td>{{dateTimeFormat(props.item.startDate)}}</td>
            <td>{{dateTimeFormat(props.item.endDate)}}</td>
            <td>{{props.item.status}}</td>
            <td>{{props.item.errors}}</td>
            <td>{{dateTimeFormat(props.item.dateProcessed)}}</td>
            <td>
              <v-icon small class="mr-2"  v-if="props.item.status == 'Błąd przetwarzania'" @click="processAgain(props.item.id)" title="Przetwórz ponownie">fa-repeat</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import {visitService} from "@/services";
import swal from "sweetalert";
import dayjs from "dayjs";
import {mapActions} from "vuex";

export default {
  name: "BuforP1",
  data() {
    return {
      headers: [
        {text: 'Pacjent',  align: 'left', value: 'patient'},
        {text: 'Terapeuta',  align: 'left', value: 'therapist'},
        {text: 'Data godz. poczatkowa', align: 'left', value: 'startDate'},
        {text: 'Data godz. końcowa', align: 'left', value: 'endDate'},
        {text: 'Status', align: 'left', value: 'status'},
        {text: 'Błędy', align: 'left', value: 'errors'},
        {text: 'Data przetworzenia', align: 'left', value: 'dateProcessed'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      items: []
    }
  },
  created() {
    this.updateTitle('Bufor wizyt w systemie P1')
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions("title", ["updateTitle"]),
    dateTimeFormat(val)
    {
      if(val)
      {
          return dayjs(val).format('DD-MM-YYYY HH:mm')
      }
      return ''
    },
    getData()
    {
      visitService.GetVisitsP1Status().then((result) => {
        this.items = result.data.result
      }).catch(() => {
        this.showError('Błąd pobierania bufora P1')
      })
    },
    processAgain(id)
    {
      visitService.retryP1Visit(id).then(() => {
        this.getData()
      }).catch(error => {
        let err = error.response
        if (err && err.data != null && err.data.error && err.data.error.message) {
          this.showError(err.data.error.message)
        } else {
          this.showError('Nie można ponowić przetwarzania wizyty')
        }
      })
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      })
    }
  }
}
</script>

<style scoped>

</style>
